import { Component, computed, inject, signal } from '@angular/core';
import { Location } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-my-account-mercadopago',
    templateUrl: './my-account-mercadopago.component.html',
    styleUrls: ['./my-account-mercadopago.component.css'],
    standalone: false
})
export class MyAccountMercadopagoComponent {
  private _usuarioService = inject(UsuarioService);
  private _authService = inject(AuthService);
  private _loadingService = inject(LoadingService);
  private router = inject(Router);
  private _location = inject(Location);

  error = signal<string>('');
  loading = computed(() => this._loadingService.isLoading());

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    // Si necesitás (re)cargar usuario/cliente desde backend, hacelo bajo el loader:
    await this._loadingService.run(async () => {
      try {
        // Asegura bootstrap de sesión (idempotente, ok en web/nativo)
        await this._authService.ensureSession();
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudo cargar tu cuenta.');
        this.router.navigate(['/sign-in']);
      }
    });
  }

  redirecting = signal<boolean>(false);

  async mercadopago(): Promise<void> {
    if (this.redirecting()) return;

    this.error.set('');
    this.redirecting.set(true);

    try {
      const userId = this._usuarioService.usuario().id!;

      const resUrl = await firstValueFrom(
        this._usuarioService.getMercadoPagoUrlAutorizacion(userId)
      );

      const decodedUrl = decodeURIComponent(resUrl);

      window.location.replace(decodedUrl);
    } catch (e: any) {
      console.error('Error al obtener URL MercadoPago', e);
      this.redirecting.set(false);
      this.error.set('Error al obtener la URL de autorización de Mercado Pago.');
    }
  }

  isMobile(): boolean {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }

  back(){
    this._location.back();
  }
}
